export enum RoutesEnum {
  ASSET_GENIUS = '/users/auth/asset_genius',
  FORGOT_PASSWORD = '/users/password/new',
  HOME = '/',
  SIGN_IN = '/sign_in',
  USERS_SIGN_IN = '/users/sign_in',
}
